var e={name:"LegendHeader",props:{title:{type:String,required:!1}}};export{e as default};
